// extracted by mini-css-extract-plugin
export default {"bouncing_loader":"styles_bouncing_loader__aCYR5"};